import React from 'react';

import { useDispatch } from 'react-redux';
import { Button } from 'antd';

import { startProTrial } from '../../../../../../slices/packagesInfo/index.thunk';
import { Features, isFeatureEnabled } from '../../../../../../featureToggles/features';

interface IProps {
  onClose: () => void;
}

export const StartTrialButton = (props: IProps): React.ReactElement | null => {
  const { onClose } = props;
  const dispatch = useDispatch();

  const startTrial = () => {
    dispatch(startProTrial());
    onClose();
  };

  if (!isFeatureEnabled(Features.TrialsOfTiers)) {
    return null;
  }

  return (
    <Button
      type="primary"
      onClick={startTrial}
    >
      Start trial
    </Button>
  );
};
